import React from 'react';
import { CheckboxInput, Typography } from '@hpstellar/core/visId';

import useProductCompare from '../../../../../hooks/useProductCompare';
import { getCompare } from '../../../../get-product-props';

import './compare-input.less';

export const CompareInput = ({ product, ctaText = 'Compare', classname }) => {
    const compareHooks = useProductCompare();
    const { compareBtnProps } = getCompare(product, compareHooks);
    const { compareChecked, onCompare } = compareBtnProps || {};
    return (
        <div className={`compare-input${!onCompare ? ' compare-disabled' : ''} ${classname ? classname : ''}`} onClick={onCompare}>
            <CheckboxInput checked={compareChecked} disabled={!onCompare} />
            <Typography variant="caption" className="compare-input-cta-text">{ctaText}</Typography>
        </div>
    );
};

export default ({ product, ctaText = 'Compare', classname }) => {
    return (
        <div className="product-compare">
            <CompareInput product={product} ctaText={ctaText} classname={classname}/>
            <Typography variant="footnotes">{product.sku}</Typography>
        </div>
    );
};
